import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const GetItemAcceptancePageData = () =>
    request({
        url: ApiURL.Query.StudioQueryURLs.ItemAcceptanceCancellationQueryURL.GetItemAcceptancePageData,
        method: RequestType.GET,
    });

const GetMatchingSetByModelOption = (params: { specialCode: string; colorCode: string }) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.ItemAcceptanceCancellationQueryURL.GetMatchingSetByModelOption,
        method: RequestType.GET,
        params,
    });

const GetItemCancellationPageData = () =>
    request({
        url: ApiURL.Query.StudioQueryURLs.ItemAcceptanceCancellationQueryURL.GetItemCancellationPageData,
        method: RequestType.GET,
    });

const QueryCancelledShots = (params?: Record<string, unknown>) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.ItemAcceptanceCancellationQueryURL.QueryCancelledShots,
        method: RequestType.GET,
        params,
    });

export const ItemAcceptanceCancellationQuery = {
    GetItemAcceptancePageData,
    GetMatchingSetByModelOption,
    GetItemCancellationPageData,
    QueryCancelledShots,
};
